import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Upload-images.css";
//import { Position, Popover  } from "@blueprintjs/core";
//import jimp from 'jimp';


import moment from "moment";

const localthumbnailDateTime = (date, languageSelected) => {

    let dateStr = "";

    switch (languageSelected) {
        case "fi":
            dateStr = moment((new Date(date))).format('DD.MM.yy HH:mm:ss');
            break;
        case "en":
            dateStr = moment((new Date(date))).format('yy/MM/DD HH:mm:ss');
            break;
        case "es":
            dateStr = moment((new Date(date))).format('DD/MM/yy HH:mm:ss');
            break;
        default:
            dateStr = moment((new Date(date))).format('yy/MM/DD HH:mm:ss');
    }
    return dateStr
}

const ListItem = 
    React.memo(function ListItem({ itemSrc, index, thumbnail, languageSelected }) {
        //console.log(`Render ${index}`);
        return <img className="imagesThumbnail" key={thumbnail.acquisitiontime} src={itemSrc} alt={index} 
            title={`${localthumbnailDateTime(thumbnail.acquisitiontime, languageSelected)} / H:${thumbnail.height} x W:${thumbnail.width}`} />
    });

export default class UploadImages extends React.PureComponent {

    handleClickedImage = (selectedImagesThumbnail, thumbnail) => {
        const { handleSelectedImage } = this.props;
        if (selectedImagesThumbnail !== thumbnail.id )
            handleSelectedImage(thumbnail);
    }

    clName = (selectedImagesThumbnail,id,i) => {
            return selectedImagesThumbnail !== id ? "imageBox" : "imageBoxSelected";
        };


    render() {

        const { imagesThumbnailBySequences, selectedImagesThumbnail, thumbnailsData, languageSelected } = this.props;

    return (
        <div>
            
            <div id="thumbnails" className="thumbnails">
       
                {imagesThumbnailBySequences &&
                        imagesThumbnailBySequences.map((thumbnail, index) => (
                            <div key={index} className={this.clName(selectedImagesThumbnail, thumbnail.id, index) }  
                            onClick={() => { 
                                this.handleClickedImage(selectedImagesThumbnail, thumbnail);                      
                            }}>
                                <ListItem itemSrc={thumbnailsData[index]} index={index} thumbnail={thumbnail} languageSelected={languageSelected} />
                        </div>
                ))}
            </div >
            
        </div>

    );
    }
}

UploadImages.propTypes = {
  
    imagesThumbnailBySequences: PropTypes.array.isRequired,
    thumbnailsData: PropTypes.array.isRequired,
    selectedImagesThumbnail: PropTypes.string.isRequired,
    handleSelectedImage: PropTypes.func.isRequired, 
    languageSelected: PropTypes.string.isRequired
}